<h3 mat-dialog-title>{{ data.title }}</h3>
<mat-dialog-content class="small-content">
    <p [innerHTML]="data.content"></p>
    <p *ngIf="data.danger"
       class="text-danger font-weight-bolder"
       [innerHTML]="data.danger"></p>
</mat-dialog-content>
<mat-dialog-actions>
    <button [class.invisible]="data.hideCancelButton" [attr.aria-label]="'cancel'" (click)="closeAndCancel()" class="btn btn-outline-secondary">
        {{data.cancelButton || 'Cancel'}}
    </button>
    <div class="ml-3">
        <button *ngIf="data.secondaryButton" [attr.aria-label]="'secondary action'" (click)="closeSecondary()" class="btn btn-outline-primary">{{data.secondaryButton}}</button>
        <button [attr.aria-label]="'confirm'" (click)="closeAndConfirm()" class="btn btn-primary">{{data.confirmButton}}</button>
    </div>
</mat-dialog-actions>
